import React, { useEffect, useState } from "react";
import SummaryApi from "../common/index";
import { FaChevronLeft, FaChevronRight, FaTrash, FaEdit } from "react-icons/fa";

const PastYatra = () => {
  const [yatras, setYatras] = useState([]);
  const [currentIndexes, setCurrentIndexes] = useState([]);
const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchYatras = async () => {
      try {
        const response = await fetch(SummaryApi.getAllYatra.url, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        setYatras(data);
        setCurrentIndexes(data.map(() => 0));
      } catch (error) {
        console.error("Failed to fetch yatras:", error);
      } finally {
      setLoading(false);
      }
    };

    fetchYatras();
  }, []);

  const handlePrev = (index) => {
    setCurrentIndexes((prev) => {
      const images = yatras[index]?.imageUrls || [];
      if (images.length === 0) return prev;
      const updated = [...prev];
      updated[index] = (updated[index] - 1 + images.length) % images.length;
      return updated;
    });
  };

  const handleNext = (index) => {
    setCurrentIndexes((prev) => {
      const images = yatras[index]?.imageUrls || [];
      if (images.length === 0) return prev;
      const updated = [...prev];
      updated[index] = (updated[index] + 1) % images.length;
      return updated;
    });
  };

  const formatDate = (date) =>
    new Intl.DateTimeFormat("en-GB").format(new Date(date));

    const SkeletonCard = () => (
  <div className="bg-white rounded-md shadow-md animate-pulse">
    <div className="w-full h-48 bg-gray-200 rounded-t-md"></div>
    <div className="p-4">
      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
      <div className="h-3 bg-gray-200 rounded w-1/2 mb-2"></div>
      <div className="h-3 bg-gray-200 rounded w-2/3 mb-2"></div>
      <div className="h-3 bg-gray-200 rounded w-1/4"></div>
    </div>
  </div>
);


  return (
  <div className="py-14 bg-gray-100"
  style={{ backgroundImage: "url('/varkaripariwar_bg_photo.png')" }}>
     <h2 className="text-3xl md:text-4xl text-orange-800 text-center  font-yatra mb-10">
      यशस्वी यात्रा
      </h2>
    <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-6">
      {loading ? (
    // Show 3 skeletons
    Array.from({ length: 3 }).map((_, index) => (
      <SkeletonCard key={index} />
    ))
  ) : (
    yatras.length > 0 &&
  yatras
  .filter((yatra) => yatra.status === "complete")
  .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
  .map((yatra, index) => {
          const images = yatra.imageUrls || [];
          const currentImg = images[currentIndexes[index] || 0];

          return (
            <div
              key={yatra._id}
              className="bg-white rounded-md shadow-md hover:shadow-lg transition-shadow relative"
            >
              <div className="relative group">
                {currentImg && (
                  <img
                    src={currentImg}
                    alt="Yatra"
                    className="w-full h-48 object-cover"
                  />
                )}

                {/* Previous Arrow */}
                <button
                  onClick={() => handlePrev(index)}
                  className="hidden group-hover:flex absolute top-1/2 left-3 transform -translate-y-1/2 bg-white/70 hover:bg-white/90 p-2 rounded-full shadow-md"
                >
                  <FaChevronLeft className="text-gray-700" />
                </button>

                {/* Next Arrow */}
                <button
                  onClick={() => handleNext(index)}
                  className="hidden group-hover:flex absolute top-1/2 right-3 transform -translate-y-1/2 bg-white/70 hover:bg-white/90 p-2 rounded-full shadow-md"
                >
                  <FaChevronRight className="text-gray-700" />
                </button>
              </div>

              <div className="p-4">
  <h3 className="text-lg font-yatra text-gray-800 mb-1">
    {yatra.yatraName}
  </h3>
  <hr className="border-gray-300 mb-3" />
  <p className="text-sm mb-1">
    <span className="text-orange-600 font-semibold">
      प्रारंभ दिनांक:{" "}
    </span>
    {formatDate(yatra.startDate)}
  </p>
  <p className="text-sm mb-2">
    <span className="text-orange-600 font-semibold">
      प्रति व्यक्ती दर:{" "}
    </span>
    ₹{yatra.pricePerPerson}
  </p>
  <p className="text-sm">
    <span className="text-orange-600 font-semibold">
      स्थळे:{" "}
    </span>
    {yatra.visitingPlaces || "माहिती उपलब्ध नाही"}
  </p>
</div>

            </div>
          );
       })
  )}
    </div>
    </div>
  );
};

export default PastYatra;
